import React from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import {
  InventoryTabItemName,
  inventoryStore,
} from '../../../../../InventoryStore';
import { useRowConfig } from '../../../../../hooks';
import { RowBase } from '../../../../Table/RowBase/RowBase';

const PackMaxBookingRowComponent: React.FC<{ packId: number }> = ({
  packId,
}) => {
  const { setDrawerPackConfig } = useStore(
    inventoryStore,
    useShallow((state) => ({
      setDrawerPackConfig: state.setDrawerPackConfig,
    }))
  );

  const { inventoryPacks, formatter, onDuplicate } = useRowConfig({
    entityId: packId,
    entityType: InventoryTabItemName.Packs,
    fieldName: 'maxBooking',
    formatterName: 'maxBooking',
  });

  if (!inventoryPacks) {
    return null;
  }

  return (
    <RowBase
      label="Max Booking"
      hasSetting
      onClickSettings={() => {
        setDrawerPackConfig(packId, true);
      }}
      entityId={packId}
      fieldName="maxBooking"
      entityType={InventoryTabItemName.Packs}
      formatter={formatter}
      defaultValue={0}
      isEditable
      onDuplicate={onDuplicate}
      canDuplicateEmptyValue
    />
  );
};

export const PackMaxBookingRow = React.memo(PackMaxBookingRowComponent);
